<template>
  <div class="preview-wrapper">
        <div class="content">
          <cover-page
            :coverInfo="currentReportData.reportDetails.coverInfo"
            :reportInfo="currentReportData.reportDetails"
          ></cover-page>
          </div>
          <div class="content">
          <signature-page
            :reportInfo="currentReportData.reportDetails"
            :signature="currentReportData.signature"
          >
            <div style="padding:0 12pt;" v-html="currentReportData.htmlContentAll[0]"></div>
          </signature-page>
          </div>
          
            <div class="content" v-for="(htmlContent,index) in currentReportData.htmlContentAll.slice(1)" :key="index+'ccc'">
            <normal-page
              :reportInfo="currentReportData.reportDetails"
              :totalPage="currentReportData.reportDetails.totalPage"
              :currentPage="index+2"
              :key="index+'ci'"
            >
              <div style="padding:0 12pt;" v-html="htmlContent"></div>
            </normal-page>
            </div>
          <div v-for="(htmlImg,index) in currentReportData.htmlImgAll" class="content" :key="index+'img'">
            <img-page
              :reportInfo="currentReportData.reportDetails"
              :currentPage="index+1+currentReportData.htmlContentAll.length"
              :imgEle="htmlImg"
              :key="index+'cgg'"
            >
            </img-page>
          </div>
          <van-loading type="spinner" color="#1989fa" v-if="currentReportData.loading"/>
      <button
        v-if="currentReportData.accessoryFileUrl"
        @click="toUrl(currentReportData.accessoryFileUrl)"
        class="exist"
      >查看附件</button>
      <button v-if="!currentReportData.accessoryFileUrl" disabled>无附件</button>
  </div>
</template>
<script>
import signaturePage from "./ReportModuleBase/SignaturePage.vue";
import normalPage from "./ReportModuleBase/NormalPage.vue";
import coverPage from "./ReportModuleBase/CoverPage.vue";
import imgPage from "./ReportModuleBase/ImgPage.vue";


let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

export default {
  name: "reportView",
  components: {
    signaturePage,
    normalPage,
    coverPage,
    imgPage
  },
  props: {
    report_display_no:{
      type:String,
      default:""
    },
    report_no: {
      type: Number,
      default: NaN
    },
  },
  data() {
    return {
      currentReportData: {
        loading: false,
        currentShowPage: 1,
        htmlContentAll: [" "],
        htmlImgAll:[],
        coverInfo: {
          sampleName: "",
          spec: "-",
          client: "",
          clientAddress: ""
        },
        reportNo: NaN,
        accessoryFileUrl: "",
        reportDetails: {
          sampleName: "",
          contractNo: NaN,
          sampleAmount: "",
          report_display_no: "",
          project_display_no: "",
          testLocation: "",
          receiptDate: "",
          testDate: "",
          sampleInfo: "",
          standardList: [],
          langguage:undefined,
          totalPage: 1
        },
        signature: {
          inspector: {
            sDate: "",
            sName: "",
            sUrl: ""
          },
          verifier: {
            sDate: "",
            sName: "",
            sUrl: ""
          },
          authorizer: {
            sDate: "",
            sName: "",
            sUrl: ""
          }
        }
      }
    };
  },
  watch: {
    report_no: function(newNo) {
      this.get_current_report_data(newNo,'id');
    },
    report_display_no:function(newNo){
      this.get_current_report_data(newNo,'display_no');
    }
  },
  computed: {
    
  },
  mounted(){
    if(this.report_display_no){
      this.get_current_report_data(this.report_display_no,'display_no');
    }
  },
  methods: {
    
    get_current_report_data(value,keyType) {
      this.currentReportData.loading = true;
      this.$axios
        .post(this.$url + "/ask_report_info", {
          userToken: userToken,
          askData: "reportBaseInfo",
          keyType:keyType,
          report_id: value
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.currentReportData.currentShowPage = 1;
            this.currentReportData.reportDetails =
              response.data.res_record.reportDetails;
            this.currentReportData.coverInfo =
              response.data.res_record.coverInfo;
            let restObj = document.createElement("div");
            this.currentReportData.htmlContentAll = [];
            for(let i of JSON.parse(
              response.data.res_record.reportContent.paragraph_content
            ).content){
              restObj.innerHTML = i;
              let tagSpan = restObj.getElementsByTagName("span");
              Array.prototype.forEach.call(tagSpan, element => {
                element.style.cssText =
                  "text-align:justify;font-size:0.6rem;line-height:1rem;font-family: 宋体;";
              });
              let tagP = restObj.getElementsByTagName("p");
              Array.prototype.forEach.call(tagP, element => {
                if (element.getElementsByTagName("strong").length === 0) {
                  element.style.cssText +=
                    "text-align:justify;text-indent:32px;font-size:0.6rem;line-height:1rem;font-family: 宋体;";
                } else {
                  element.style.cssText =
                    "text-align:justify;font-size:0.6rem;line-height:1rem;font-family: 宋体;";
                }
              });
               let tagTable = restObj.getElementsByTagName("table");
              Array.prototype.forEach.call(tagTable, element => {
                element.style.cssText = "width:100%;margin:0.5rem 0.3rem;border-collapse:collapse;";
              });
              let tagTd = restObj.getElementsByTagName("td");
              Array.prototype.forEach.call(tagTd, element => {
                element.style.cssText += "height:1rem;font-size:0.5rem;";
              });
              let TagPInTd = restObj.querySelectorAll("table p");
              Array.prototype.forEach.call(TagPInTd, element => {
                element.style.cssText = "text-align:center;line-height:0.6rem;font-size:0.5rem;";
              });
              let TagSpanInTd = restObj.querySelectorAll("table span");
              Array.prototype.forEach.call(TagSpanInTd, element => {
                element.style.cssText = "font-size:0.5rem;font-family: 宋体;";
              });
              this.currentReportData.htmlContentAll.push(restObj.innerHTML);
            }
            this.currentReportData.htmlImgAll = JSON.parse(
              response.data.res_record.reportContent.paragraph_content
            ).img;
            this.currentReportData.accessoryFileUrl =
              response.data.res_record.reportContent.accessory_word_code;
            this.currentReportData.reportNo = value.toString();
            this.currentReportData.signature =
              response.data.res_record.signature;
            for (let i in this.currentReportData.signature) {
                if (this.currentReportData.signature[i].sUrl) {
                  this.currentReportData.signature[i].sUrl = this.$fileUrlFac(this.currentReportData.signature[i].sUrl,authData.sfileRight);
                }
              }
            this.currentReportData.loading = false;
          } else {
            this.$toast.fail("未查到相关报告信息！");
          }
        });
    },
    toUrl(url) {
      window.open(this.$fileUrlFac(url,authData.sfileRight));
    },
    handleCurrentChange(value) {
      this.Tpage.currentPage = value;
      this.get_data();
    },
    handleSizeChange(value) {
      this.Tpage.currentSize = value;
      this.Tpage.currentPage = 1;
      this.get_data();
    },
    previewPage(value) {
      if (
        this.currentReportData.currentShowPage + value >= 0 &&
        this.currentReportData.currentShowPage + value <
          this.currentReportData.reportDetails.totalPage + 1
      ) {
        this.currentReportData.currentShowPage += value;
      }
    }
  }
};
</script>
<style scoped>
.preview-wrapper {
  padding: 0.5rem;
  overflow: hidden;
}

.content {
  width: 100%;
  color: #000;
  outline: #aaa solid 1px;
  text-align: center;
  position: relative;
  margin-bottom:0.4rem;
}

button{
  border:none;
  outline:none;
  float:right;
  color:#fff;
  background: #fa7962;
  font-size:0.6rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.1rem;
  margin-bottom:2rem;
}

button.exist{
  background: rgb(10, 75, 8);
}


</style>